import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';

import * as styles from './extrasItem.css';
import { ReactNode, useState } from 'react';
import { Typography } from '@design-system/components/typography/typography';
import { Col, Row } from '@design-system/components/grid/grid';
import { faCheck, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { Pill } from '@client/new/pages/promotions/view/components/Pill';

import { IconButton } from '@design-system/components/button/iconButton';
import { typeToLabel } from '../../viewModel/extras.mappers';
import { ContentTypeName } from '../../model/extras.domain';

export type ExtrasItemProps = {
  title: string;
  imageURL?: string;
  description: ReactNode[];
  type: ContentTypeName;
  isPublished: boolean;
  onDelete: () => void;
  onToggleItem: () => void;
  onEdit: () => void;
  dndProps: DraggableProvidedDragHandleProps | undefined | null;
};

export const ExtrasItem = (p: ExtrasItemProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleToggleItem = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsLoading(true);
    p.onToggleItem();
    setTimeout(() => setIsLoading(false), 1000);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    p.onDelete();
  };

  return (
    <Row
      className={styles.wrapper}
      alignCenter
      onClick={() => p.onEdit()}
      {...p.dndProps}
    >
      <Col className="w-16">
        <img src={p.imageURL} alt={p.title} className={styles.image} />
      </Col>
      <Col>
        <Typography variant="body" size="large" fontWeight="normal">
          {p.title}
        </Typography>
        <Row>
          {p.description.map((desc, index) => (
            <Typography
              key={index}
              variant="body"
              size="small"
              className={styles.description}
            >
              {desc}
            </Typography>
          ))}
        </Row>
      </Col>
      <Col>
        <Pill type="Inactive" content={typeToLabel(p.type)} />
      </Col>
      <div className="ml-auto">
        {p.isPublished ? (
          <IconButton
            loading={isLoading}
            icon={faCheck}
            variant="filled"
            color="success"
            onClick={handleToggleItem}
          >
            {isLoading ? 'Publishing' : 'Published'}
          </IconButton>
        ) : (
          <IconButton
            loading={isLoading}
            variant="filled"
            color="primaryTonal"
            onClick={handleToggleItem}
          >
            {isLoading ? 'Unpublishing' : 'Publish'}
          </IconButton>
        )}
      </div>
      <IconButton onClick={handleDelete} icon={faTrash} variant="text" />
    </Row>
  );
};
